import React from 'react'

import Anchor from '@/components/base/anchor'
import { FooterCopyrightProps } from './types'
import useTranslations from '@/hooks/useTranslations'

const FooterCopyright: React.FunctionComponent<FooterCopyrightProps> = ({
  policyNavigation = [],
}) => {
  const { translation } = useTranslations()

  if (!Array.isArray(policyNavigation)) {
    return null
  }

  return (
    <div className="footer-v2-copyright">
      <div className="footer-v2-copyright-information">
        {translation('copyright')}
      </div>
      <nav className="footer-v2-copyright-menu">
        <ul>
          {policyNavigation?.map((item, index) => (
            <li key={index}>
              <Anchor
                href={item.href}
                target={item.target}
                dangerouslySetInnerHTML={{ __html: item.title }}
              />
            </li>
          ))}
        </ul>
      </nav>
    </div>
  )
}

export default FooterCopyright
